/* eslint-disable no-undef */
import { WeatherWidgetLazy } from './weatherWidgetLazy';

const props = [];

export const WeatherWidgetsDirective = (reactDirective) => reactDirective(WeatherWidgetLazy, props);
WeatherWidgetsDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('weatherWidgetsScreen', WeatherWidgetsDirective);
